import * as types from '../actions/types'
import Immutable from 'immutable'

import { tableCols, findValues } from '../containers/Plantillas'
import { plantilla, isPrimitive } from '../utils/helpers'

const columnas = Immutable.fromJS(tableCols)

const INITIAL_STATE = Immutable.fromJS({
	plantillas: [],
	page: 1,
	showRecords: 100,
	totalRecords: 0,
	orderBy: {
		field: null,
		asc: false
	},
	modalCreate: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
	modalFilter: {
		show: false,
		filters: []
	},
})

export default function (state = INITIAL_STATE, action) {
	let id
	let data
	let index
	switch (action.type) {
		case types.OBTENER_PLANTILLAS:
			state = state.set('plantillas', Immutable.fromJS(action.payload.data))
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords)
			return state
		case types.CONMUTAR_SELECCION_PLANTILLA:
			state = state.setIn(['plantillas', action.payload.index, 'selected'], action.payload.checked)
			return state
		case types.CONMUTAR_SELECCION_TODOS_PLANTILLAS:
			state.get('plantillas').forEach((x, n) => {
				if (action.payload) {
					if (x.get('visible')) {
						state = state.setIn(['plantillas', n, 'selected'], action.payload)
					}
				} else {
					state = state.setIn(['plantillas', n, 'selected'], action.payload)
				}
			})
			return state
		case types.ORDENAR_PLANTILLAS:
			state = state.set('orderBy', action.payload.orderBy)
			return state
		case types.MOSTRAR_MODAL_CREAR_PLANTILLA:
			state = state.setIn(['modalCreate', 'show'], action.payload.show)
			state = state.setIn(['modalCreate', 'title'], action.payload.title)
			state = state.setIn(['modalCreate', 'mode'], action.payload.mode)
			if (action.payload.mode === 'create') {
				state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(plantilla()))
			} else if (action.payload.mode === 'edit') {
				index = state.get('plantillas').findIndex(x => x.get('id') === action.payload.id)
				state = state.setIn(['modalCreate', 'data'], state.getIn(['plantillas', index]))
			}
			return state
		case types.MODIFICAR_INPUTS_PLANTILLAS:
			if (isPrimitive(action.payload.value)) {
				state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
			} else {
				if (action.payload.immutable === false) {
					state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
				} else {
					state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
				}
			}
			return state
		case types.CREAR_ACTUALIZAR_PLANTILLA:
			id = action.payload.id
			index = state.get('plantillas').findIndex(x => x.get('id') === id)
			if (index !== -1) {
				state = state.setIn(['plantillas', index], Immutable.fromJS(action.payload))
			} else {
				state = state.set('plantillas', state.get('plantillas').push(Immutable.fromJS(action.payload)))
			}
			state = state.setIn(['modalCreate', 'show'], false)
			state = state.setIn(['modalCreate', 'title'], '')
			state = state.setIn(['modalCreate', 'mode'], '')
			state = state.setIn(['modalCreate', 'data'], null)
			return state
		case types.DESHABILITAR_BOTON_MODAL_PLANTILLAS:
			state = state.setIn(['modalCreate', 'btnDisabled'], action.payload)
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		case types.ELIMINAR_PLANTILLA:
			index = state.get('plantillas').findIndex(x => x.get('id') === action.payload)
			state = state.deleteIn(['plantillas', index])
			state = state.setIn(['modalDelete', 'show'], false)
			state = state.setIn(['modalDelete', 'action'], null)
			state = state.setIn(['modalDelete', 'message'], null)
			return state
        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS:
            state = state.setIn(['modalFilter', 'show'], action.payload)
            return state
        case types.ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS:
            const firstCol = columnas.first()
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .push(Immutable.fromJS({ 
                    column: firstCol.get('Value'),
                    operator: '===',
                    value: '',
                    checked: false,
                    comparison: firstCol.get('Type'),
                    apply: false
                }))
            )
            return state
        case types.ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS:
            state = state.setIn(['modalFilter', 'filters'], state.getIn(['modalFilter', 'filters']).filter(item => !item.get('checked')))
            return state
        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS:
            state = state.setIn(['modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked)
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS:
            if (action.payload.attr === 'column') {
                state = state.setIn(['modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('Value') === action.payload.value).get('Type'))
            }
            state = state.setIn(['modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value)
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_PLANTILLAS:
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .map(x => {
                    x = x.set('apply', true)
                    return x
                })
            )
            return state
		case types.CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS:
            state = state.set('showRecords', action.payload)
            return state
	   default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/plantillas.js